module.exports = __webpack_public_path__ + "media/audios/kid/lesson_3/audio15-c710a0f7e1b8bf4bf4eaf3294246f26a.m4a";